import { InjectionToken, Provider } from '@angular/core'
import { ActionReducerMap } from '@ngrx/store'
import { MbSiteContextState } from '../state'
import * as fromCountries from './countries.reducer'

export function getReducers () {
  return { countries: fromCountries.reducer }
}

export const reducerToken = new InjectionToken<ActionReducerMap<MbSiteContextState>>('MbSiteContextReducers')

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
}
